export default "__VITE_ASSET__a2206e65__"